import * as types from '../../constants/ActionTypes';

/**
 * Methods for API for different operations with route points
 * @type {Object}
 */
export const API_METHODS = {
  add: 'post',
  edit: 'put',
  remove: 'delete',
};

/**
 * Possible actions dispatched at the end of the `sendRoutePoint` saga
 * @type {Array[String]}
 */
export const SEND_ROUTE_POINT_ENDINGS = [
  types.SEND_ROUTE_POINT_SUCCESS,
  types.SEND_ROUTE_POINT_FAILURE,
];

/**
 * Checks if action is last dispatched of the `sendRoutePoint`
 * E.g. of usage:
 * ```js
 * // Check if `SEND_ROUTE_POINT` saga was ended
 * take(isSendRoutePointEnding);
 * ```
 * @param {Object} action - current action to check
 * @param {String?} pointId - optional route point id
 * @returns {Boolean}
 */
export function isSendRoutePointEnding(action, pointId) {
  return (
    SEND_ROUTE_POINT_ENDINGS.includes(action.type) &&
    (pointId ? action.routePoint === pointId : true)
  );
}
